import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import JobListItem from './JobListItem'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { Job } from 'api/smartRecruiter/types'
import { getJobPostings } from 'api/smartRecruiter/smartRecruiter'
import CommunityBanner from './CommunityBanner'
import { formatIsoDate } from 'lib/datetime/dateUtils'

const JobListContainer = styled.div`
  width: 100%;
  border: none;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(16)};
  margin-top: ${rem(15)};
  border-radius: ${props => props.theme.borderRadius.S};
`

function OpenPositions() {
  const [jobs, setJobs] = useState<Array<Job>>([])
  const [status, setStatus] = useState<'loading' | 'error' | 'no-jobs' | 'available'>('loading')

  useEffect(() => {
    const fetchJobs = async() => {
      setStatus('loading')
      try {
        const jobs = await getJobPostings()
        if (jobs.length === 0) {
          setStatus('no-jobs')
        } else {
          setJobs(jobs)
          setStatus('available')
        }
      } catch(err) {
        console.error('Failed to fetch jobs', err)
        setStatus('error')
      }
    }

    fetchJobs()
  }, [])

  if (status === 'loading') {
    return (
      <JobListContainer>
        <Group direction="vertical" horizontalAlign="center">
          <BodyText variant="small">Loading jobs...</BodyText>
        </Group>
      </JobListContainer>
    )
  }

  if (status === 'error') {
    return (
      <JobListContainer>
        <BodyText variant="small" style={{ color: 'red' }}>
          Sorry, we couldn't load the job listings. Please try again later.
        </BodyText>
      </JobListContainer>
    )
  }

  if (status === 'no-jobs') {
    return (
      <JobListContainer>
        <BodyText variant="small">No job openings at the moment.</BodyText>
      </JobListContainer>
    )
  }

  return (
    <JobListContainer>
      <Group direction="vertical" gap={24}>
        <Group direction="vertical" gap={8}>
          {jobs.map(job => (
            <JobListItem
              key={job.id}
              title={job.title}
              location={job.location}
              employmentType={job.employmentType}
              date={formatIsoDate(new Date(job.date))}
              description={job.description}
              href={job.applyUrl}
              target="_blank"
            />
          ))}
        </Group>
        <CommunityBanner
          description="If you are thinking about a future with us, sign up to the relevant talent community and be informed of any new opportunities."
          title="We're always on the lookout for talent"
        />
      </Group>
    </JobListContainer>
  )
}

OpenPositions.displayName = 'OpenPositions'
export default OpenPositions
